import { render, staticRenderFns } from "./StatsVisits.vue?vue&type=template&id=5ffc50b4&scoped=true"
import script from "./StatsVisits.vue?vue&type=script&lang=js"
export * from "./StatsVisits.vue?vue&type=script&lang=js"
import style0 from "./StatsVisits.vue?vue&type=style&index=0&id=5ffc50b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffc50b4",
  null
  
)

export default component.exports